export default __webpack_public_path__ + "static/media/error-occured.0b0f8114.svg";